import { IoRemove } from "react-icons/io5";
import { IoAdd } from "react-icons/io5";
import "./style.css";
import Tooltip from "../tooltip";

interface CounterProps {
  title: string;
  message: string;
  val: number;
  min: number;
  max: number;
  changeVal: Function;
}

const Counter = (props: CounterProps) => {
  return (
    <div className="counter-container">
      <span className="counter-title font-lato">{props.title + " :"} </span>
      <div className="flex items-center mt-4 md:mt-0">
        <div className="counter-container-block">
          <button
            aria-label="decrement-btn"
            data-testid="decrement-btn"
            className="counter-btns"
            disabled={props.val === props.min}
            onClick={() => props.changeVal(props.val - 1)}
            data-track="decrement-button"
          >
            <IoRemove />
          </button>
          <span className="counter-value">{props.val}</span>
          <button
            aria-label="increment-btn"
            data-testid="increment-btn"
            className="counter-btns"
            disabled={props.val === props.max}
            onClick={() => props.changeVal(props.val + 1)}
            data-track="increment-button"
          >
            <IoAdd />
          </button>
        </div>
        <Tooltip message={props.message} />
      </div>
    </div>
  );
};

export default Counter;
